import { useStage, useStageTimer } from "@empirica/core/player/classic/react";
import React from "react";

export function Timer() {
  const timer = useStageTimer();
  const stage = useStage();
  const stageName = stage?.get("name");
  const discussionPrepEnabled = stage?.get("discussionPrepEnabled") === true;
  const discussionPrepEndsAt = Number(stage?.get("discussionPrepEndsAt") || 0);
  const isDiscussionPrepActive =
    stageName === "discussion" &&
    discussionPrepEnabled &&
    discussionPrepEndsAt > Date.now();

  if (stageName === "finalVote") {
    return (
      <div className="flex flex-col items-center">
        <div className="text-sm text-gray-400 font-medium">No time limit</div>
      </div>
    );
  }

  let remaining;
  if (isDiscussionPrepActive) {
    remaining = Math.max(
      0,
      Math.ceil((discussionPrepEndsAt - Date.now()) / 1000)
    );
  } else if (timer?.remaining || timer?.remaining === 0) {
    remaining = Math.round(timer?.remaining / 1000);
  }

  return (
    <div className="flex flex-col items-center">
      <h1 className="tabular-nums text-3xl text-gray-500 font-semibold">
        {humanTimer(remaining)}
      </h1>
      {stageName === "discussion" && discussionPrepEnabled && (
        <div className="text-[11px] uppercase tracking-wide text-gray-400">
          {isDiscussionPrepActive ? "Prep" : "Discussion"}
        </div>
      )}
    </div>
  );
}

function humanTimer(seconds) {
  if (seconds === null || seconds === undefined) {
    return "--:--";
  }

  let out = "";
  const s = seconds % 60;
  out += s < 10 ? "0" + s : s;

  const min = (seconds - s) / 60;
  if (min === 0) {
    return `00:${out}`;
  }

  const m = min % 60;
  out = `${m < 10 ? "0" + m : m}:${out}`;

  const h = (min - m) / 60;
  if (h === 0) {
    return out;
  }

  return `${h}:${out}`;
}
